import { useTranslate } from "ra-core";

import { FINANCE_EXPENSE_CATEGORIES } from "../financeOptions";

/** Translated label of an expense category; unknown values are shown as stored */
export const useCategoryLabel = () => {
  const translate = useTranslate();
  return (category: string) =>
    (FINANCE_EXPENSE_CATEGORIES as readonly string[]).includes(category)
      ? translate(`crm.finance.expenses.categories.${category}`)
      : category;
};
